import {
  Platform
} from 'quasar'

import global from 'app/src/global'



// import
// mock
// from 'app/src/store/module/debase'
import {
  decode,
  encode
} from './../../assets/js/base64';
import Cookies from 'js-cookie'
import {
  getMeetingData_api,
  sendPvAction_api,
  sendUvAction_api,
  sendUserOrder_api,
  getVideo_api,
  exchangeAndSendEmail_api,
  getDownloadList_api,
  downloadFile_api,
  getCommentList_api,
  commentSubmit_api,
  giveALike_api,
  getTopicList_api,
  getRandomLuckyCode_api,
  submitQuestion_api,
  getUserOrder_api,
  loginUserInfo_api,
  getLuckyCodeList
} from '../../boot/api'

// 会议数据格式梳理
const meetingData = (params) => {

  //let baseData = params['data']['data']['list'] || params['data']['data']['data'];
  let baseData = params['data']['list'];
  let _metData = null;

  _metData = [{
      main: [],
      second: [],
      video: [],
    },
    {
      main: [],
      second: []
    }
  ];

  let _secondData_o = [];
  let _secondData_t = [];

  //数据格式

  baseData.forEach((ele) => {

    let clidArray = ele['clid'].split('-')
    //主
    if (parseInt(clidArray[0]) === 1 && parseInt(clidArray[1]) === 1) {

      _metData[0]['main'].push(ele);
    }
    //一分
    if (parseInt(clidArray[0]) === 1 && parseInt(clidArray[1]) === 2) {
      _secondData_o.push(ele);
    }

    //二主
    if (parseInt(clidArray[0]) === 2 && parseInt(clidArray[1]) === 1) {
      _metData[1]['main'].push(ele);
    }
    //二分
    if (parseInt(clidArray[0]) === 2 && parseInt(clidArray[1]) === 2) {
      _secondData_t.push(ele);
    }
    //点播视频
    if (parseInt(clidArray[0]) === 10) {
      _metData[0]['video'].push(ele);
    }

  });

  _metData[0]['second'].push({

    data: _secondData_o.slice(0, 5)
  }, {
    data: _secondData_o.slice(5, 10)
  }, {
    data: _secondData_o.slice(10, 14)
  })
  //
  _metData[1]['second'].push({
    data: _secondData_t.slice(0, 4)
  }, {
    data: _secondData_t.slice(4, 8)
  }, {
    data: _secondData_t.slice(8, 9)
  })


  return _metData
}

//已预约数据日程梳理
const OrderMeetingData = (params) => {

  let baseData = params['data']['data']['data'];
  let _metData = null;

  _metData = {
    main: [],
    second: []
  };


  /**  */
  baseData.forEach((ele) => {
    let clidArray = ele['clid'].split('-');
    if (parseInt(clidArray[0]) === 1 && parseInt(clidArray[1]) === 1) {

      _metData['main'].push(ele);
    }
    if (parseInt(clidArray[0]) === 2 && parseInt(clidArray[1]) === 1) {
      _metData['main'].push(ele);
    }
    if (parseInt(clidArray[0]) === 2 && parseInt(clidArray[1]) === 2) {
      _metData['second'].push(ele);
    }
    if (parseInt(clidArray[0]) === 1 && parseInt(clidArray[1]) === 2) {
      _metData['second'].push(ele);
    }
    if (parseInt(clidArray[0]) === 10) {
      _metData['second'].push(ele);
    }
  });

  return _metData
}


//
const baseInfo = {

  state: {

    CurrentVid: "",
    IsMobile: Platform['is']['mobile'] || false, //是否是移动终端
    RoateUser: false, //是否在个人中心
    Interact: false, //是否在互动有礼
    Download: false, //是否在下载中心
    LuckyNumber: "", //当前用户的福来号码
    UserActive: JSON.parse(localStorage.getItem('userActive')) || [], // 用户是否在当前浏览器第一次登录
    UserOrder: [{
      main: []
    }],
    InteractProess: [],
    Cookie: { // 用户信息
      UserEmail: "",
      Gid: "",
      FirstName: "",
      lastName: "",
      Duty: "",
      TC: "",
      companyName: "",
    },
    CanChangeText: global.INCHANGECONTENT,
    MettingData: [ // 会议日程数据
      {
        main: []
      },
      {
        main: []
      }
    ],
    VideoData: [] // 产品及解决方案中视频的数据
  },

  actions: {
    //登录拦截 cookie 信息
    LoginEventAction({
      commit,
      state,
      dispatch
    }, params) {
      return new Promise((resolve, reject) => {
        console.log(process.env.ENV_COOKIE_NAME)


        let userCookie = Cookies.get(process.env.ENV_COOKIE_NAME) || "";

        if (userCookie !== '') {

          userCookie = userCookie.substring(6);
          userCookie = userCookie.substring(0, userCookie.length - 6);

          userCookie = JSON.parse(decode(userCookie));

          let firstName = userCookie.firstName || '';
          let lastName = userCookie.lastName || '';
          let duty = userCookie.duty == "undefined" ? '' : userCookie.duty;


          if (userCookie.gid !== state.Cookie['Gid']) {
            /** 写入cookie 信息 */
            commit('SET_COOKIE', {
              UserEmail: userCookie.email || '-',
              Gid: userCookie.gid,
              FirstName: unescape(firstName.replace(/\\/g, "%")),
              Duty: unescape(duty.replace(/\\/g, "%")),
              LastName: unescape(lastName.replace(/\\/g, "%")),
              TC: ""
            });
            // 获取用户信息

            //dispatch('LoginUser');
            /**获取一次福来号码*/
          //  dispatch('getLuckyCode');

          }

          resolve();

        } else {

          reject()
        }

      });

    },



    LoginUser({
      commit,
      state,
      dispatch
    }, param) {
      return new Promise((resolve, reject) => {

        loginUserInfo_api().then(res => {

          let result = res['data']['data']['data'];

          commit('INTERACTPROESS', result['trensureStatus'] || 0);

          commit('SET_COOKIE', Object.assign(state.Cookie, {
            companyName: result['companyName'] || '--'
          }));

          dispatch('initAction', result);

          dispatch("SetUserUvAaction", {
            TrackName: 'userEvent-Login',
            TrackTextName: "登录",
          })

          resolve()
        }).catch(err => {
          reject(err)
        })

      })

    },

    /**
     * @description: 获取视频数据
     */
    GetVideoData({
      commit,
      state,
      dispatch
    }) {
      return new Promise((resolve, reject) => {
        const debaseData = {
          "timestamp": 1609985778094,
          "data": {
            "success": true,
            "data": [{
                "title": "宾利云利用 oneAPI 提升产品配置体验",
                "content": "展示与宾利汽车公司合作举办的产品设计与客户体验重点演示。您可以通过使用我们基于 Osprey 渲染器和英特尔® oneAPI 的英特尔® Osprey studio 应用访问交互式虚拟演示厅。",
                "key": 9,
                "time": null,
                "poster": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/1-1.jpg",
                "posterMobile": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/1-2.jpg",
                "src": "{\"HD\": \"https://vod.market.itcgb.cn/0d4a40acee374d828825a7c9d50f635e/ca86f0868f0b4cf3b46937bea45de0d7-0d4e4a99de47d86c164b2177e9c5e693-hd.m3u8\",\"SD\": \"https://vod.market.itcgb.cn/0d4a40acee374d828825a7c9d50f635e/ca86f0868f0b4cf3b46937bea45de0d7-0bd8c3c2851dc50a8b895ae032e11f02-sd.m3u8\",\"FD\": \"https://vod.market.itcgb.cn/0d4a40acee374d828825a7c9d50f635e/ca86f0868f0b4cf3b46937bea45de0d7-e3442ebdfca3de7de5ec090bc2653c8c-fd.m3u8\"}",
                "videoSrc":
                {
                  "HD": "https://intel-dcc.smarket.net.cn/ipdc2020/video/宾利云使用%20oneAPI%20提升产品配置体验.mp4 ",
                  // "SD": "https://vod.market.itcgb.cn/0d4a40acee374d828825a7c9d50f635e/ca86f0868f0b4cf3b46937bea45de0d7-0bd8c3c2851dc50a8b895ae032e11f02-sd.m3u8",
                  // "FD": "https://vod.market.itcgb.cn/0d4a40acee374d828825a7c9d50f635e/ca86f0868f0b4cf3b46937bea45de0d7-e3442ebdfca3de7de5ec090bc2653c8c-fd.m3u8"
                }
              },
              {
                "title": "英特尔® cAdvisor",
                "content": "展示英特尔® cAdvisor的优势，该工具为基于容器的遥测技术，目前能支持 PERF 类事件。",
                "key": 10,
                "time": null,
                "poster": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/2-1.jpg",
                "posterMobile": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/2-2.jpg",
                "src": "{\"HD\": \"https://vod.market.itcgb.cn/50a44f6350724ccbabbf244c427a77f4/cd153ac121aa43c4a8fe1c3bd4d4eb81-315d559953ff804d4ee8480afd538cd5-hd.m3u8\",\"SD\": \"https://vod.market.itcgb.cn/50a44f6350724ccbabbf244c427a77f4/cd153ac121aa43c4a8fe1c3bd4d4eb81-61e1a92d4136007353a0c85d1361f960-sd.m3u8\",\"FD\": \"https://vod.market.itcgb.cn/50a44f6350724ccbabbf244c427a77f4/cd153ac121aa43c4a8fe1c3bd4d4eb81-16e0ddcb1ae651f35778649c88386078-fd.m3u8\"}",
                "videoSrc": {
                  "HD": "https://intel-dcc.smarket.net.cn/ipdc2020/video/英特尔®%20cAdvisor.mp4",
                  // "SD": "https://vod.market.itcgb.cn/50a44f6350724ccbabbf244c427a77f4/cd153ac121aa43c4a8fe1c3bd4d4eb81-61e1a92d4136007353a0c85d1361f960-sd.m3u8",
                  // "FD": "https://vod.market.itcgb.cn/50a44f6350724ccbabbf244c427a77f4/cd153ac121aa43c4a8fe1c3bd4d4eb81-16e0ddcb1ae651f35778649c88386078-fd.m3u8"
                }
              },
              {
                "title": "云自适应优化",
                "content": "演示英特尔对基于特定云工作负载的性能和效率进行自动优化，并讲解这综合解决方案如何提供云自适应优化和其带来的优势。",
                "key": 11,
                "time": null,
                "poster": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/3-1.jpg",
                "posterMobile": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/3-2.jpg",
                "src": "{\"HD\": \"https://vod.market.itcgb.cn/87281978b96d4e938306d31e0fcb13dd/43fca300e4b44f2b995fba2fd2029237-c95bd6c93143948fbb2f35850551d923-hd.m3u8\",\"SD\": \"https://vod.market.itcgb.cn/87281978b96d4e938306d31e0fcb13dd/43fca300e4b44f2b995fba2fd2029237-e6fc9d2bcca165f18466b20b652f7fd9-sd.m3u8\",\"FD\": \"https://vod.market.itcgb.cn/87281978b96d4e938306d31e0fcb13dd/43fca300e4b44f2b995fba2fd2029237-be4d0d4eeadb1fb20f24b9a3d4d867ee-fd.m3u8\"}",
                "videoSrc": {
                  "HD": "https://intel-dcc.smarket.net.cn/ipdc2020/video/云自适应优化.mp4",
                  // "SD": "https://vod.market.itcgb.cn/87281978b96d4e938306d31e0fcb13dd/43fca300e4b44f2b995fba2fd2029237-e6fc9d2bcca165f18466b20b652f7fd9-sd.m3u8",
                  // "FD": "https://vod.market.itcgb.cn/87281978b96d4e938306d31e0fcb13dd/43fca300e4b44f2b995fba2fd2029237-be4d0d4eeadb1fb20f24b9a3d4d867ee-fd.m3u8"
                }
              },
              {
                "title": "Arista 云负载均衡工具",
                "content": "Arista 7170 系列是一个基于高性能英特尔® Tofino™ 系列的100 Gbps 可编程路由器。它突出了围绕 NAT 和负载均衡的性能，非常酷炫。 ",
                "key": 12,
                "time": null,
                "poster": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/4-1.jpg",
                "posterMobile": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/4-2.jpg",
                "src": "{\"HD\": \"https://vod.market.itcgb.cn/ec955c7f04444320b710c9898dc47c64/b0dedcee4fc64eeb9b57a83b8c6046a8-1936cc28e5db476e86c34e1a4c42d6fb-hd.m3u8\",\"SD\": \"https://vod.market.itcgb.cn/ec955c7f04444320b710c9898dc47c64/b0dedcee4fc64eeb9b57a83b8c6046a8-fc9f9c866a4e9fb80eaff98885606b19-sd.m3u8\",\"FD\": \"https://vod.market.itcgb.cn/ec955c7f04444320b710c9898dc47c64/b0dedcee4fc64eeb9b57a83b8c6046a8-2493b76dd1ea8d6dd8282591ee9a5daa-fd.m3u8\"}",
                "videoSrc": {
                  "HD": "https://intel-dcc.smarket.net.cn/ipdc2020/video/Arista.mp4",
                  // "SD": "https://vod.market.itcgb.cn/ec955c7f04444320b710c9898dc47c64/b0dedcee4fc64eeb9b57a83b8c6046a8-fc9f9c866a4e9fb80eaff98885606b19-sd.m3u8",
                  // "FD": "https://vod.market.itcgb.cn/ec955c7f04444320b710c9898dc47c64/b0dedcee4fc64eeb9b57a83b8c6046a8-2493b76dd1ea8d6dd8282591ee9a5daa-fd.m3u8"
                }
              },
              {
                "title": "英特尔® 至强® 可扩展处理器的 “Scale It Up” 造型工具",
                "content": "英特尔一款新工具，可以提供可视化的图像，帮助您清晰地判断和量化当调整组件时 - 处理器、存储和网络 - 将会对使用英特尔® 至强® 可扩展处理器的云和系统负载性能有什么影响。",
                "key": 13,
                "time": null,
                "poster": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/5-1.jpg",
                "posterMobile": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/5-2.jpg",
                "src": "{\"HD\": \"https://vod.market.itcgb.cn/66a1ee68da3b43a0a2d66bd20f3ee260/ce527d1913e543f09d191d9998841866-f9d673ddcaf9f73676e27d3786a92be6-hd.m3u8\",\"SD\": \"https://vod.market.itcgb.cn/66a1ee68da3b43a0a2d66bd20f3ee260/ce527d1913e543f09d191d9998841866-62df6d21532d4434355a2c5aeac6b9a6-sd.m3u8\",\"FD\": \"https://vod.market.itcgb.cn/66a1ee68da3b43a0a2d66bd20f3ee260/ce527d1913e543f09d191d9998841866-8725a5c44644c89ba61de81633caaae3-fd.m3u8\"}",
                "videoSrc": {
                  "HD": "https://intel-dcc.smarket.net.cn/ipdc2020/video/英特尔®%20至强®%20可扩展处理器%20的%20Scale%20It%20Up%20选型工具.mp4",
                  // "SD": "https://vod.market.itcgb.cn/66a1ee68da3b43a0a2d66bd20f3ee260/ce527d1913e543f09d191d9998841866-62df6d21532d4434355a2c5aeac6b9a6-sd.m3u8",
                  // "FD": "https://vod.market.itcgb.cn/66a1ee68da3b43a0a2d66bd20f3ee260/ce527d1913e543f09d191d9998841866-8725a5c44644c89ba61de81633caaae3-fd.m3u8"
                }
              },
              {
                "title": "OCP NIC 3.0 概述",
                "content": "服务器联网的下一步：OCP NIC 3.0 为网络适配器定义了一个全新的、基于社区的开放标准，让适配器可以采用各个供应商的网卡使用于任何服务器。",
                "key": 14,
                "time": null,
                "poster": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/6-1.jpg",
                "posterMobile": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/6-2.jpg",
                "src": "{\"HD\": \"https://vod.market.itcgb.cn/abc1741f90ee48ab96fb62cd213479b9/a47e6a2d32804b7d94dd95affbdcec29-887024663dace14b3ed71aaaad7ffc81-hd.m3u8\",\"SD\": \"https://vod.market.itcgb.cn/abc1741f90ee48ab96fb62cd213479b9/a47e6a2d32804b7d94dd95affbdcec29-88fcd8deba910ed4dc2b49e4267385e6-sd.m3u8\",\"FD\": \"https://vod.market.itcgb.cn/abc1741f90ee48ab96fb62cd213479b9/a47e6a2d32804b7d94dd95affbdcec29-08c351fde44a1c0856aed74391b47621-fd.m3u8\"}",
                "videoSrc": {
                  "HD": "https://intel-dcc.smarket.net.cn/ipdc2020/video/OCP%20NIC%203.0%20概述.mp4",
                  // "SD": "https://vod.market.itcgb.cn/abc1741f90ee48ab96fb62cd213479b9/a47e6a2d32804b7d94dd95affbdcec29-88fcd8deba910ed4dc2b49e4267385e6-sd.m3u8",
                  // "FD": "https://vod.market.itcgb.cn/abc1741f90ee48ab96fb62cd213479b9/a47e6a2d32804b7d94dd95affbdcec29-08c351fde44a1c0856aed74391b47621-fd.m3u8"
                }
              },
              {
                "title": "Redis 使用 ADQ 的演示",
                "content": "基于英特尔新一代以太网卡 - E810 ADQ 功能的 Redis 演示",
                "key": 15,
                "time": null,
                "poster": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/7-11.jpg",
                "posterMobile": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/7-2.jpg",
                "src": "{\"HD\": \"https://vod.market.itcgb.cn/8d2fb2f3ffd445249e34c3438168e1c0/c93ed2db069f49c2843c3be946307e43-85cfe2c17761c35430198abba08f865c-hd.m3u8\",\"SD\": \"https://vod.market.itcgb.cn/8d2fb2f3ffd445249e34c3438168e1c0/c93ed2db069f49c2843c3be946307e43-cb5427ce85566606aade7968de899a7d-sd.m3u8\",\"FD\": \"https://vod.market.itcgb.cn/8d2fb2f3ffd445249e34c3438168e1c0/c93ed2db069f49c2843c3be946307e43-72a9e417086f0eaa8988085f29adbdaf-fd.m3u8\"}",
                "videoSrc": {
                  "HD": "https://intel-dcc.smarket.net.cn/ipdc2020/video/Redis%20使用%20ADQ%20的演示.mp4",
                  // "SD": "https://vod.market.itcgb.cn/8d2fb2f3ffd445249e34c3438168e1c0/c93ed2db069f49c2843c3be946307e43-cb5427ce85566606aade7968de899a7d-sd.m3u8",
                  // "FD": "https://vod.market.itcgb.cn/8d2fb2f3ffd445249e34c3438168e1c0/c93ed2db069f49c2843c3be946307e43-72a9e417086f0eaa8988085f29adbdaf-fd.m3u8"
                }
              },
              {
                "title": "基于英特尔服务器GPU的Android 云游戏平台演示",
                "content": "基于英特尔服务器 GPU 的 Android 云游戏平台演示",
                "key": 16,
                "time": null,
                "poster": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/9-1.jpg",
                "posterMobile": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/9-2.jpg",
                "src": "{\"HD\": \"https://vod.market.itcgb.cn/cc3f19c235cc4e6cb53329f52755d65f/5f73a548b3ef4a18b82f067c0165c24e-434b6035154627be5b9200d686c81723-hd.m3u8\",\"SD\": \"https://vod.market.itcgb.cn/cc3f19c235cc4e6cb53329f52755d65f/5f73a548b3ef4a18b82f067c0165c24e-bd27320c9edd6b2bbad3fcb8d87b7b7a-sd.m3u8\",\"FD\": \"https://vod.market.itcgb.cn/cc3f19c235cc4e6cb53329f52755d65f/5f73a548b3ef4a18b82f067c0165c24e-4341b9e7f5e5db3b300c2843deeb1e0d-fd.m3u8\"}",
                "videoSrc": {
                  "HD": "https://intel-dcc.smarket.net.cn/ipdc2020/video/基于英特尔服务器GPU的Android%20云游戏平台演示.mp4",
                  // "SD": "https://vod.market.itcgb.cn/cc3f19c235cc4e6cb53329f52755d65f/5f73a548b3ef4a18b82f067c0165c24e-bd27320c9edd6b2bbad3fcb8d87b7b7a-sd.m3u8",
                  // "FD": "https://vod.market.itcgb.cn/cc3f19c235cc4e6cb53329f52755d65f/5f73a548b3ef4a18b82f067c0165c24e-4341b9e7f5e5db3b300c2843deeb1e0d-fd.m3u8"
                }
              },
              {
                "title": "基于英特尔服务器 GPU 的 H.264 和 H.265 视频转码演示",
                "content": "基于英特尔服务器 GPU 的 H.264 和 H.265 视频转码演示",
                "key": 17,
                "time": null,
                "poster": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/8-11.jpg",
                "posterMobile": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/8-12.jpg",
                "src": "{\"HD\": \"https://vod.market.itcgb.cn/860afecf9fda4b14ba3f499ff7cdbdb4/3f893a31d44e460687d174dea8bd4752-314067ba8e19d1920f302837b86db4b5-hd.m3u8\",\"SD\": \"https://vod.market.itcgb.cn/860afecf9fda4b14ba3f499ff7cdbdb4/3f893a31d44e460687d174dea8bd4752-3e82dc4f1ba9d61356658512ae1d40aa-sd.m3u8\",\"FD\": \"https://vod.market.itcgb.cn/860afecf9fda4b14ba3f499ff7cdbdb4/3f893a31d44e460687d174dea8bd4752-38ad23407d7ed036444a72e6ca668fc4-fd.m3u8\"}",
                "videoSrc": {
                  "HD": "https://intel-dcc.smarket.net.cn/ipdc2020/video/基于英特尔服务器%20GPU%20的H.264%20和H.265%20视频转码演示.mp4",
                  // "SD": "https://vod.market.itcgb.cn/860afecf9fda4b14ba3f499ff7cdbdb4/3f893a31d44e460687d174dea8bd4752-3e82dc4f1ba9d61356658512ae1d40aa-sd.m3u8",
                  // "FD": "https://vod.market.itcgb.cn/860afecf9fda4b14ba3f499ff7cdbdb4/3f893a31d44e460687d174dea8bd4752-38ad23407d7ed036444a72e6ca668fc4-fd.m3u8"
                }
              },
              {
                "title": null,
                "content": null,
                "key": 18,
                "time": null,
                "poster": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/10-1.jpg",
                "posterMobile": "https://intel-dcc.smarket.net.cn/ipdc2020/img/solution/10-2.jpg",
                "src": null,
                "videoSrc": {
                  "HD": null,
                  "SD": null,
                  "FD": null
                }
              }
            ]
          }
        }
        const list = debaseData['data']['data']
        commit('SET_VIDEODATA', list)
        resolve(list);
        // getVideo_api()
        //   .then(res => {
        //     const list = res['data']['data']['data']
        //     commit('SET_VIDEODATA', list)
        //     resolve(res);
        //   })
        //   .catch(err => {
        //     reject(err)
        //   })
      })
    },

    /**
     * @description: 获取资料专区
     */
    GetDownloadList({
      commit,
      state,
      dispatch
    }) {
      return new Promise((resolve, reject) => {
        getDownloadList_api()
          .then(res => {
            const {
              data
            } = res['data']
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /**
     * @description: 下载文件
     */
    DownloadFile({
      commit,
      state,
      dispatch
    }, params) {
      return new Promise((resolve, reject) => {
        downloadFile_api(params)
          .then(res => {
            const {
              data
            } = res['data']
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    /**
     * @description: 提交问卷
     */
    SubmitQuestion({
      commit,
      state,
      dispatch
    }, dynamicParams) {
      return new Promise((resolve, reject) => {
        submitQuestion_api(dynamicParams)
          .then(res => {
            const {
              data
            } = res['data']
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /**
     * @description: 获取提问列表
     */
    GetCommentList({
      commit,
      state,
      dispatch
    }, params) {
      return new Promise((resolve, reject) => {
        getCommentList_api(params)
          .then(res => {
            const {
              data
            } = res['data']
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /**
     * @description: 提交提问
     */
    CommentSubmit({
      commit,
      state,
      dispatch
    }, params) {
      return new Promise((resolve, reject) => {
        commentSubmit_api(params)
          .then(res => {
            const {
              data
            } = res['data']
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /**
     * @description: 兑奖并发送邮件
     */
    ExchangeAndSendEmail({
      commit,
      state,
      dispatch
    }, status) {
      return new Promise((resolve, reject) => {
        exchangeAndSendEmail_api(status)
          .then(res => {
            const {
              data
            } = res['data']
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /**
     * @description: 提交提问
     */
    GiveALike({
      commit,
      state,
      dispatch
    }, params) {
      return new Promise((resolve, reject) => {
        giveALike_api(params)
          .then(res => {
            const {
              data
            } = res['data']
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    /**
     * @description: 获取话题
     */
    GetTopicList({
      commit,
      state,
      dispatch
    }) {
      return new Promise((resolve, reject) => {
        getTopicList_api()
          .then(res => {
            const {
              data
            } = res['data']
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /**
     * @description: 获取 5 期福来开奖列表
     * @return {*}
     */
    GetLuckyCodeList({
      commit,
      state,
      dispatch
    }) {
      return new Promise((resolve, reject) => {
        getLuckyCodeList()
          .then(res => {
            const data = res['data']['data']
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },


    GetMettingData({ //获取日程相关数据
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        const _MeData = {
          "timestamp": 1609985877060,
          "data": {
            "success": true,
            "list": [{
                "clid": "1-1-1",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=0&c=1",
                "title": "英特尔—同心共济，驱动云创新",
                "time": "13:30-14:30",
                "more": null,
                "desc": "英特尔—同心共济，驱动云创新主题演讲介绍了全球互联网和云计算市场的业务规模和未来增长潜力，结合新冠肺炎对全球数字化转型及IT技术的影响，并以 5G、AI、智能边缘和万物云化四个技术趋势为基础，制定了英特尔以数据为中心的产品组合。通过硬件和软件的整合，加上产业链合作伙伴的紧密合作，为客户提供全栈式的解决方案，更好的应对从云到端的各项挑战，助力客户把握新的业务机会，积极推进技术创新。",
                "guestList": [{
                    "guest": "Navin Shenoy",
                    "guestDesc": "英特尔执行副总裁<br/>数据平台事业部总经理",
                    "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-1-1-2.png",
                    "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-1-1-2.png"
                  },
                  {
                    "guest": "Jason L. Grebe",
                    "guestDesc": "英特尔企业副总裁<br/>云平台和技术事业部总经理",
                    "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-1-1-1.png",
                    "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-1-1-1.png"
                  }
                ],
                "startTime": "2020-11-17 13:30",
                "endTime": "2020-11-17 14:30",
                "clidFirst": 1,
                "clidSecond": 1,
                "clidThird": 1
              },
              {
                "clid": "1-1-2",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=0&c=2",
                "title": "阿里新一代云服务器硬件架构 - 方升",
                "time": "14:30-15:00",
                "more": null,
                "desc": "阿里新一代云服务器硬件架构 - 方升，是面向大规模云数据中心基础设施的技术架构、规范和标准，目的是打造能够更好满足未来公有云应用需求、高效率、低成本的云原生服务器产品。演讲内容包括传统服务器、传统数据中心在大规模云数字中心应用的不足、阿里云原生服务器架构的特点及技术规范。",
                "guestList": [{
                  "guest": "郭锐",
                  "guestDesc": "阿里服务器资深架构师",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-1-2.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/1-1-2.png"
                }],
                "startTime": "2020-11-17 14:30",
                "endTime": "2020-11-17 15:00",
                "clidFirst": 1,
                "clidSecond": 1,
                "clidThird": 2
              },
              {
                "clid": "1-2-1",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=1&c=0",
                "title": "英特尔® 至强® 产品路线图 101",
                "time": "15:00-16:00",
                "more": null,
                "desc": "演讲嘉宾将以游泳赛道的概念区分不同服务器平台的价值定位，并介绍这一背景下的英特尔® 至强® 可扩展第三代 (ICX，Ice Lake) 以及下一代 (SPR, Sapphire Rapids) CPU SKU 和平台选项。内容包括对 Ice Lake 主要功能的概述，以及它们是如何映射到几类工作负载的加权混合中，以生成更有效的性能指标。",
                "guestList": [{
                  "guest": "Eric Dahlen",
                  "guestDesc": "英特尔数据平台事业部，云企解决方案事业部 CTO",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-1.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/1-2-1.png"
                }],
                "startTime": "2020-11-17 15:00",
                "endTime": "2020-11-17 16:00",
                "clidFirst": 1,
                "clidSecond": 2,
                "clidThird": 1
              },
              {
                "clid": "1-2-2",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=2&c=0",
                "title": "明日数据中心 - 在供电、冷却和基础设施设计方面的未来趋势",
                "time": "15:00-16:00",
                "more": null,
                "desc": "数据中心长期以来一直依靠传统的空调基础设施来满足机房服务器设备在冷却方面的需求。考虑到服务器冷却能耗占数据中心总能耗的很大一部分（高达 40％），许多设施运营者都在致力于改善冷却策略以提高效率。为驱动互联网服务或应用的高功率处理器，其所产生的热量也超过了传统冷却基础设施所能承载，从而迫使数据中心运营者采用新的方法来满足其冷却需求。本节将介绍设备供电和冷却设计的趋势。",
                "guestList": [{
                  "guest": "Nishi Ahuja",
                  "guestDesc": "英特尔资深首席工程师",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-2.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/1-2-2.png"
                }],
                "startTime": "2020-11-17 15:00",
                "endTime": "2020-11-17 16:00",
                "clidFirst": 1,
                "clidSecond": 2,
                "clidThird": 2
              },
              {
                "clid": "1-2-3",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=3&c=0",
                "title": "云存储演化：你准备好了吗？",
                "time": "15:00-16:00",
                "more": null,
                "desc": "非易失性内存经历了很长时间去抵挡 DRAM 的竞争，并在存储密度上超越机械硬盘，得到了长足的发展。本节旨在回答以下问题：在向 PCIe4 过渡的过程中，在 NVMe、型态和高性能固态硬盘方面有哪些注意事项？英特尔的存储事业部和软件专家在为您解决痛点的过程中，做出了哪些改进？各家 CSP 怎样才能迅速利用起这些新技术？ ",
                "guestList": [{
                  "guest": "Allison Goodman",
                  "guestDesc": "英特尔资深首席工程师",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-3.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/1-2-3.png"
                }],
                "startTime": "2020-11-17 15:00",
                "endTime": "2020-11-17 16:00",
                "clidFirst": 1,
                "clidSecond": 2,
                "clidThird": 3
              },
              {
                "clid": "1-2-4",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=4&c=0",
                "title": "用于加速云服务的可编程网络交换技术",
                "time": "15:00-16:00",
                "more": null,
                "desc": "进一步简述英特尔在网络互连方面的愿景和战略如何去满足数据中心网络不断增长的需求。让大家了解 P4 和英特尔® Tofino 在可编程网络互连方面的最新趋势，为网络服务带来的创新使用方式，以获得实时可见性和提高效率。并聆听 CSP/OEM 讲述他们如何与英特尔合作解决云服务提供商在网络方面面临的关键挑战。   ​",
                "guestList": [{
                  "guest": "Ed Doe",
                  "guestDesc": "英特尔数据平台事业部副总裁，Barefoot 部门总经理",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-4.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/1-2-4.png"
                }],
                "startTime": "2020-11-17 15:00",
                "endTime": "2020-11-17 16:00",
                "clidFirst": 1,
                "clidSecond": 2,
                "clidThird": 4
              },
              {
                "clid": "1-2-5",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=5&c=0",
                "title": "为云而“生”的英特尔软件",
                "time": "15:00-16:00",
                "more": null,
                "desc": "本节将对英特尔在云领域的软件工作进行概述，并围绕即将推出的 Ice Lake 服务器平台中，针对性能的新功能提供一些具体示例。",
                "guestList": [{
                    "guest": "Ronak Singhal",
                    "guestDesc": "英特尔院士",
                    "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-5-1.png",
                    "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/1-2-5-1.png"
                  },
                  {
                    "guest": "Arjan Van De Ven",
                    "guestDesc": "英特尔院士",
                    "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-5-2.png",
                    "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/1-2-5-2.png"
                  }
                ],
                "startTime": "2020-11-17 15:00",
                "endTime": "2020-11-17 16:00",
                "clidFirst": 1,
                "clidSecond": 2,
                "clidThird": 5
              },
              {
                "clid": "1-2-6",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=1&c=1",
                "title": "英特尔内存故障预测技术助力美团提升服务器稳定性",
                "time": "16:00-16:30",
                "more": null,
                "desc": "为了加强美团服务器的稳定性，英特尔与美团协助部署英特尔内存故障预测技术。演讲嘉宾将会介绍美团在内存故障预测技术方面的探索与实践，与英特尔合作取得的成果及下一步工作计划。",
                "guestList": [{
                  "guest": "刘亚景",
                  "guestDesc": "美团资深系统架构师",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-6.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/1-2-6.png"
                }],
                "startTime": "2020-11-17 16:00",
                "endTime": "2020-11-17 16:30",
                "clidFirst": 1,
                "clidSecond": 2,
                "clidThird": 6
              },
              {
                "clid": "1-2-7",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=2&c=1",
                "title": "京东—云时代数据中心硬件挑战与创新",
                "time": "16:00-16:30",
                "more": null,
                "desc": "京东与英特尔共同为智联云开发的整机柜服务器方案。本节演讲嘉宾将会介绍京东智联云和英特尔联合创新设计的模块化服务器。",
                "guestList": [{
                  "guest": "陈国峰",
                  "guestDesc": "京东智联云 IDC 与基础运维部硬件研发总监",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-7.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/1-2-7.png"
                }],
                "startTime": "2020-11-17 16:00",
                "endTime": "2020-11-17 16:30",
                "clidFirst": 1,
                "clidSecond": 2,
                "clidThird": 7
              },
              {
                "clid": "1-2-8",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=3&c=1",
                "title": "《智能宕机预警系统》助力百度云安全可靠运行",
                "time": "16:00-16:30",
                "more": null,
                "desc": "百度和英特尔在智能宕机预警技术进行了相关研究，以提高百度云数据中心的稳定性。演讲嘉宾将会就相关的研究成果进行分享，并分享其在百度云数据中心上面的实践收益。",
                "guestList": [{
                  "guest": "刘星星",
                  "guestDesc": "百度资深研发工程师",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-8.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/1-2-8.png"
                }],
                "startTime": "2020-11-17 16:00",
                "endTime": "2020-11-17 16:30",
                "clidFirst": 1,
                "clidSecond": 2,
                "clidThird": 8
              },
              {
                "clid": "1-2-9",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=4&c=1",
                "title": "可编程交换芯片在金山云的应用实践",
                "time": "16:00-16:30",
                "more": null,
                "desc": "负载均衡【SLB】作为云网络中的关键组件，支撑着各类网络服务应用运行。而面对当下某些海量数据吞吐业务场景，基于 DPDK 的高性能x86集群横向扩展已不具备优势。金山云通过调研P4可编程交换芯片【P4-SWITCH】并与自身负载均衡业务相结合，在云数据中心网络中探索并实践出一套全新高性能转发方案。",
                "guestList": [{
                  "guest": "王永",
                  "guestDesc": "金山云资深网络研发工程师",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-9.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/1-2-9.png"
                }],
                "startTime": "2020-11-17 16:00",
                "endTime": "2020-11-17 16:30",
                "clidFirst": 1,
                "clidSecond": 2,
                "clidThird": 9
              },
              {
                "clid": "1-2-10",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=5&c=1",
                "title": "腾讯—智能钛机器学习平台 TI-ONE 及其应用实践",
                "time": "16:00-16:30",
                "more": null,
                "desc": "中文智能钛机器学习平台向下对接算力，向上承载算法和应用，横向对接数据来源，通过把三者有机结合在一起标准化了人工智能模型开发过程，简化了开发流程。英特尔开源的技术方案 Analytics Zoo 将数据分析和 AI 统一为一个集成的工作流程，实现基于 Apache Spark 的分布式 TensorFlow、PyTorch、Keras、BigDL 和 Ray 的支持。智能钛机器学习平台和英特尔 Analytics Zoo 的结合，加速了人工智能应用的落地，助力包括智能运维，金融风控等多种场景落地效率的大幅提升。",
                "guestList": [{
                    "guest": "任而金",
                    "guestDesc": "英特尔架构图形软件事业部机器学习性能组资深技术经理",
                    "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-10-1.png",
                    "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/1-2-10-1.png"
                  },
                  {
                    "guest": "高平",
                    "guestDesc": "腾讯 AI 基础产品负责人",
                    "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-10-2.png",
                    "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/1-2-10-2.png"
                  }
                ],
                "startTime": "2020-11-17 16:00",
                "endTime": "2020-11-17 16:30",
                "clidFirst": 1,
                "clidSecond": 2,
                "clidThird": 10
              },
              {
                "clid": "1-2-11",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=1&c=2",
                "title": "新华三 — QLC NVMe SSD 与英特尔® QAT 技术",
                "time": "16:30-17:00",
                "more": null,
                "desc": "当前短视频和直播成为互联网的流量担当，网络带宽和延迟的要求越来越高，CDN 的角色也越来越重要， 差异化的 CDN 服务成为云厂商和传统 CDN 服务商避免价格战的制胜法宝，今天的主题就来介绍一下英特尔的 QLC NVME 和 QAT 加速卡在 CDN 业务中的应用。",
                "guestList": [{
                  "guest": "曾海贵",
                  "guestDesc": "新华三互联网行业技术经理",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-11.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-11.png"
                }],
                "startTime": "2020-11-17 16:30",
                "endTime": "2020-11-17 17:00",
                "clidFirst": 1,
                "clidSecond": 2,
                "clidThird": 11
              },
              {
                "clid": "1-2-12",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=2&c=2",
                "title": "合作共赢，共创行业新价值—华为 FusionServer Pro V6 新品上市",
                "time": "16:30-17:00",
                "more": null,
                "desc": "华为联合英特尔发布上市2488H V6 最新一代服务器产品。同时将持续携手 SAP 及全球合作伙伴，打造FusionServer Pro 智能服务器产品及解决方案，助力行业数字化转型。合作共赢，共创行业价值未来。",
                "guestList": [{
                  "guest": "张小华",
                  "guestDesc": "华为计算产品线 <br/>FusionServer业务总裁",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-12.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-12.png"
                }],
                "startTime": "2020-11-17 16:30",
                "endTime": "2020-11-17 17:00",
                "clidFirst": 1,
                "clidSecond": 2,
                "clidThird": 12
              },
              {
                "clid": "1-2-13",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=3&c=2",
                "title": "互联世界 联想中国",
                "time": "16:30-17:00",
                "more": null,
                "desc": "联想一直致力于为中国互联网客户提供最新的技术产品和端到端的解决方案。联想为什么可以为互联网客户提供最先进的产品，最及时供货和最周到的服务。这是依靠联想集团强大的研发能力、优秀的服务体系和世界顶尖的供应链作为后盾。联想会继续助力广大中国互联网客户，与客户一起为中国互联网行业做出更大的贡献。",
                "guestList": [{
                  "guest": "周韬",
                  "guestDesc": "联想企业科技集团产品营销总经理",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-14.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-14.png"
                }],
                "startTime": "2020-11-17 16:30",
                "endTime": "2020-11-17 17:00",
                "clidFirst": 1,
                "clidSecond": 2,
                "clidThird": 13
              },
              {
                "clid": "1-2-14",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=17&i=4&c=2",
                "title": "浪潮 — 释放计算力 突破计算边界",
                "time": "16:30-17:00",
                "more": null,
                "desc": "近年来，社会“智能化”被按下了加速键，传统信息社会向智慧社会升级，背后是海量计算力支撑。在智慧时代，计算力成为与水、电一样最基本的社会基础设施。计算力就是生产力，智慧时代对数据中心提出了新的要求，要能够对外提供各种算力服务、数据服务和AI服务等。我们需构建新型数据中心—智算中心，它是经济社会运行所必须的重要基础设施，是智慧时代的新基建。那么如何应对智慧时代下对于计算力爆发性的需求，智算中心又将如何释放更强计算力，浪潮邀您一同解读。",
                "guestList": [{
                  "guest": "陈彦灵",
                  "guestDesc": "浪潮信息服务器产品线副总经理",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-13.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/1-2-13.png"
                }],
                "startTime": "2020-11-17 16:30",
                "endTime": "2020-11-17 17:00",
                "clidFirst": 1,
                "clidSecond": 2,
                "clidThird": 14
              },
              {
                "clid": "2-1-1",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=18&i=0&c=1",
                "title": "英特尔—通过优化全云端软件栈来推动 CSP 成长",
                "time": "13:45-14:05",
                "more": null,
                "desc": "英特尔—通过优化全云端软件栈来推动 CSP 成长将介绍英特尔在 CSP 领域常用的软件栈所作的优化和贡献。基于英特尔®至强®处理器的新技术，软件优化为一些常用的工作负载或服务的性能和效率进行加速，演讲嘉宾将会分享几个相关案例。",
                "guestList": [{
                    "guest": "谢晓清",
                    "guestDesc": "英特尔架构图形软件事业部副总裁兼中国区总经理",
                    "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-1-1-1.png",
                    "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/2-1-1-1.png"
                  },
                  {
                    "guest": "李宏",
                    "guestDesc": "英特尔中国区云计算软件性能优化团队总监",
                    "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-1-1-2.png",
                    "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/2-1-1-2.png"
                  }
                ],
                "startTime": "2020-11-18 13:45",
                "endTime": "2020-11-18 14:05",
                "clidFirst": 2,
                "clidSecond": 1,
                "clidThird": 1
              },
              {
                "clid": "2-1-2",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=18&i=0&c=2",
                "title": "腾讯—凝“芯”聚力，智领未来",
                "time": "14:10-14:25",
                "more": null,
                "desc": "腾讯云采用领先的自研软硬件技术，搭载英特尔高性能处理器，打造云上稳定、安全、弹性、高性能的云端计算服务；满足用户多样性全场景业务需求，无论是承载重型企业业务，还是针对个人开发者的轻量应用，都能做到伸缩自如、高性价比。",
                "guestList": [{
                  "guest": "李力",
                  "guestDesc": "腾讯云云服务器副总经理",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-1-2.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/2-1-2.png"
                }],
                "startTime": "2020-11-18 14:10",
                "endTime": "2020-11-18 14:25",
                "clidFirst": 2,
                "clidSecond": 1,
                "clidThird": 2
              },
              {
                "clid": "2-1-3",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=18&i=0&c=3",
                "title": "Facebook — 软件驱动的数据中心布局策略",
                "time": "14:25-14:40",
                "more": null,
                "desc": "大型互联网服务需要跨地域多层数据中心架构支持。在这样的环境中，硬件、软件和数据的部署都要考虑到复杂的全局优化策略。比如为了容灾的需要、软硬件和数据需要在不同故障域（failure domain）之间做到均衡部署。但是建筑、电力、网络都存在多级互相重叠的故障域；数据中心建设周期，硬件采购和换代周期，软件升级周期，实时流量变化周期并不匹配；软件之间存在复杂的依赖关系；性能优化以及流量均衡引入互相矛盾的部署原则。这些不同的因素互相制约使得我们无法用简单的人工规则来指导数据中心部署。演讲嘉宾将分享 Facebook 在这个领域中的多年实践：用基于生产系统的数据建模和多维度优化求解器来实现数据中心硬件、软件和数据的布局策略和实时均衡。",
                "guestList": [{
                  "guest": "金昀",
                  "guestDesc": "Facebook 基础架构核心系统部门资深总监",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-1-3.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/2-1-3.png"
                }],
                "startTime": "2020-11-18 14:25",
                "endTime": "2020-11-18 14:40",
                "clidFirst": 2,
                "clidSecond": 1,
                "clidThird": 3
              },
              {
                "clid": "2-2-1",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=18&i=1&c=0",
                "title": "英特尔® 至强® 可扩展处理器为人工智能加速",
                "time": "15:00-15:45",
                "more": null,
                "desc": "英特尔® 至强® 可扩展处理器为通用计算和专用的人工智能加速提供了一个平衡的平台。BFLOAT16 （BF16）是一种能匹配 IEEE FP32 精度的数据类型。与 FP32 相比，Cooper Lake 通过 BF16 和 INT8，提供 2 倍和 4 倍的峰值计算性能增益。而 Sapphire Rapids 分别提供 16 倍和 32 倍的增益。在本次演讲中，我们重点介绍了能够在英特尔® 至强® 可扩展处理器上加速人工智能的硬件和新增的软件。",
                "guestList": [{
                  "guest": "Andres Rodriquez",
                  "guestDesc": "英特尔资深首席工程师",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-2-1.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/2-2-1.png"
                }],
                "startTime": "2020-11-18 15:00",
                "endTime": "2020-11-18 15:45",
                "clidFirst": 2,
                "clidSecond": 2,
                "clidThird": 1
              },
              {
                "clid": "2-2-2",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=18&i=2&c=0",
                "title": "英特尔® 傲腾™ 持久内存技术概述",
                "time": "15:00-15:45",
                "more": null,
                "desc": "英特尔® 傲腾™ 技术与 DRAM 和 NAND 存在着根本上的差异，并从架构方面提供了独特的优势和机会。",
                "guestList": [{
                    "guest": "Dave Cohen",
                    "guestDesc": "英特尔资深首席工程师",
                    "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-2-2-1.png",
                    "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/2-2-2-1.png"
                  },
                  {
                    "guest": "Frank Ober",
                    "guestDesc": "英特尔首席工程师",
                    "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-2-2-2.png",
                    "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/2-2-2-2.png"
                  }
                ],
                "startTime": "2020-11-18 15:00",
                "endTime": "2020-11-18 15:45",
                "clidFirst": 2,
                "clidSecond": 2,
                "clidThird": 2
              },
              {
                "clid": "2-2-3",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=18&i=3&c=0",
                "title": "面向云的智能服务器和存储连接",
                "time": "15:00-15:45",
                "more": null,
                "desc": "进一步了解英特尔为满足对数据中心网络不断增长的需求，而制定的连接性愿景和战略。获取有关高性能存储网络趋势以及英特尔对 NVMe over Fabrics 支持的最新信息。听 CSP 讲述他们与英特尔在网络创新方面的合作。 ",
                "guestList": [{
                  "guest": "Brad Burres",
                  "guestDesc": "英特尔院士",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-2-3.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/2-2-3.png"
                }],
                "startTime": "2020-11-18 15:00",
                "endTime": "2020-11-18 15:45",
                "clidFirst": 2,
                "clidSecond": 2,
                "clidThird": 3
              },
              {
                "clid": "2-2-4",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=18&i=4&c=0",
                "title": "视觉云：释放智能视觉体验",
                "time": "15:00-15:45",
                "more": null,
                "desc": "在线媒体的持续增长正在驱动今天以及未来几年的显著消费增长。在本节中，我们将讨论英特尔通过硬件和软件发展视觉云的方式，它为关键的视觉云工作负载（媒体处理和分析、AR/VR、云游戏）及其分发服务 (CDN/5G) 的四个核心组成部分（解码、编码、推理、渲染）提供支持。 ",
                "guestList": [{
                  "guest": "Lynn Comp",
                  "guestDesc": "英特尔数据平台事业部副总裁，视觉基础部门和网络平台战略部门总经理",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-2-4.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/2-2-4.png"
                }],
                "startTime": "2020-11-18 15:00",
                "endTime": "2020-11-18 15:45",
                "clidFirst": 2,
                "clidSecond": 2,
                "clidThird": 4
              },
              {
                "clid": "2-2-5",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=18&i=1&c=1",
                "title": "英特尔® OpenVINO™ Model Server 在贝壳找房的应用",
                "time": "15:45-16:15",
                "more": null,
                "desc": "贝壳找房与英特尔在深度学习优化上进行合作，针对典型的户型图分割场景，通过采用 OpenVINO Model Server 有效提升推理性能。本主题将分享贝壳找房对于采用 OpenVINO Model Server 的优化心得，以及在深度学习领域的技术积累。",
                "guestList": [{
                  "guest": "简会洋",
                  "guestDesc": "贝壳资深工程师",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-2-5.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/2-2-5.png"
                }],
                "startTime": "2020-11-18 15:45",
                "endTime": "2020-11-18 16:15",
                "clidFirst": 2,
                "clidSecond": 2,
                "clidThird": 5
              },
              {
                "clid": "2-2-6",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=18&i=2&c=1",
                "title": "阿里巴巴—构建云上分布式共享内存创新架构 ",
                "time": "15:45-16:15",
                "more": null,
                "desc": "本节演讲分享有关阿里巴巴在内存池化架构的研究和成果。",
                "guestList": [{
                  "guest": "王富",
                  "guestDesc": "阿里云智能资深技术专家、服务器产品首席架构师",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-2-6.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/2-2-6.png"
                }],
                "startTime": "2020-11-18 15:45",
                "endTime": "2020-11-18 16:15",
                "clidFirst": 2,
                "clidSecond": 2,
                "clidThird": 6
              },
              {
                "clid": "2-2-7",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=18&i=3&c=1",
                "title": "疾速云原生，驶向混合云的快车道 - 青云 KubeSphere 联合英特尔，构建企业级混合云",
                "time": "15:45-16:15",
                "more": null,
                "desc": "数字化、线上化已经成为每个企业不得不面对的变革，条条大路通罗马，实现这个目标的方式和方法有很多，有些企业刚刚迈入这个门槛，有些则已经深耕了许久，后来者如果想要弯道超车，除了要做足自身的技术功课，还需要有适合自己的平台支撑和辅助，青云 KubeSphere，借助英特尔强大的企业级硬件的支持，提供了极佳用户体验的云原生数字化平台，屏蔽了碎片化的云原生技术，交付的是企业所需的价值场景，帮助企业完成业务微服务化、加速上线的频度和并保证安全性，是企业数字化转型的管家型平台。 ",
                "guestList": [{
                  "guest": "于爽",
                  "guestDesc": "青云 KubeSphere 容器平台产品负责人",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-2-7.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/2-2-7.png"
                }],
                "startTime": "2020-11-18 15:45",
                "endTime": "2020-11-18 16:15",
                "clidFirst": 2,
                "clidSecond": 2,
                "clidThird": 7
              },
              {
                "clid": "2-2-8",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=18&i=4&c=1",
                "title": "基于 VCA2/SG1 的英特尔云游戏前后端视频渲染编码方案和 OPPO 流化技术的融合",
                "time": "15:45-16:15",
                "more": null,
                "desc": "OPPO 与英特尔共同开发利用 VCA2 先进的远端渲染 GPU 池、基于容器的 Android 虚拟化技术打造全新的云端游戏渲染、编码和 Android 虚拟化能力。",
                "guestList": [{
                  "guest": "鲍永成",
                  "guestDesc": "OPPO 互联网云平台负责人",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-2-8.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/mobile/2-2-8.png"
                }],
                "startTime": "2020-11-18 15:45",
                "endTime": "2020-11-18 16:15",
                "clidFirst": 2,
                "clidSecond": 2,
                "clidThird": 8
              },
              {
                "clid": "2-2-9",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=18&i=1&c=2",
                "title": "闭幕致辞",
                "time": "16:15-16:50",
                "more": null,
                "desc": null,
                "guestList": [{
                  "guest": "Bob Swan",
                  "guestDesc": "英特尔首席执行官",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-2-10.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/pc/2-2-10.png"
                }],
                "startTime": "2020-11-18 16:15",
                "endTime": "2020-11-18 16:50",
                "clidFirst": 2,
                "clidSecond": 2,
                "clidThird": 9
              },
              {
                "clid": "2-2-10",
                "isLive": 3,
                "isOrder": false,
                "link": null,
                "title": null,
                "time": "16:20-16:25",
                "more": null,
                "desc": null,
                "guestList": null,
                "startTime": "2020-11-18 16:20",
                "endTime": "2020-11-18 16:25",
                "clidFirst": 2,
                "clidSecond": 2,
                "clidThird": 10
              },
              {
                "clid": "2-2-11",
                "isLive": 3,
                "isOrder": false,
                "link": null,
                "title": null,
                "time": "16:25-16:50",
                "more": null,
                "desc": null,
                "guestList": null,
                "startTime": "2020-11-18 16:25",
                "endTime": "2020-11-18 16:50",
                "clidFirst": 2,
                "clidSecond": 2,
                "clidThird": 11
              },
              {
                "clid": "10-1-1",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=19&i=0&c=1",
                "title": "英特尔数据中心性能套件：进行性能分析和优化的工具和方法论",
                "time": "17:00-17:00",
                "more": null,
                "desc": "针对数据中心性能的洞察，对于推动现代自动化数据中心至关重要。包括从系统配置到工作负载分析的性能洞察，有助于驱动更高效的数据中心。在本节中，我们将探索英特尔数据中心性能套件中的五种关键性能工具。​",
                "guestList": [{
                    "guest": "Josh Hilliker",
                    "guestDesc": "云服务解决方案架构师",
                    "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/ondemand/10-1-1-2.png",
                    "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/ondemand/10-1-1-2.png"
                  },
                  {
                    "guest": "Harshad Sane",
                    "guestDesc": "软件性能工程师",
                    "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/ondemand/10-1-1-1.png",
                    "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/ondemand/10-1-1-1.png"
                  },
                  {
                    "guest": "Sam Alt",
                    "guestDesc": "云软件解决方案架构师",
                    "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/ondemand/10-1-1-3.png",
                    "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/ondemand/10-1-1-3.png"
                  }
                ],
                "startTime": "2020-11-17 17:00",
                "endTime": "2020-11-17 17:00",
                "clidFirst": 10,
                "clidSecond": 1,
                "clidThird": 1
              },
              {
                "clid": "10-1-2",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=19&i=0&c=2",
                "title": "市场探索",
                "time": "17:00-18:00",
                "more": null,
                "desc": "了解当前和预测的市场趋势，包括新冠病毒带来的影响、销售额洞察和基于核心的洞察。销售额的洞察包括深入研究电子商务、数字广告、数字媒体和视频、IaaS/PaaS/SaaS 市场。",
                "guestList": [{
                  "guest": "Hannah Coutand",
                  "guestDesc": "资深总监",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/ondemand/10-1-2.png",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/ondemand/10-1-2.png"
                }],
                "startTime": "2020-11-17 17:00",
                "endTime": "2020-11-30 18:00",
                "clidFirst": 10,
                "clidSecond": 1,
                "clidThird": 2
              },
              {
                "clid": "10-1-3",
                "isLive": 3,
                "isOrder": false,
                "link": "https://bizwebcast.intel.cn/ipdc2020broadcast/vod.html?d=19&i=0&c=3",
                "title": "机密云计算：云的未来",
                "time": "17:00-18:00",
                "more": null,
                "desc": "云安全正在演变为机密计算的使用场景。我们将分享英特尔的技术路线图如何用于各种云服务场景，确保在服务里运行的工作负载安全受到保障，同时性能不受影响。",
                "guestList": [{
                  "guest": "Manish Dave",
                  "guestDesc": "首席工程师",
                  "avatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/ondemand/10-1-3.png\t",
                  "mobileAvatarUrls": "https://intel-dcc.smarket.net.cn/ipdc2020/img/ondemand/10-1-3.png\t"
                }],
                "startTime": "2020-11-16 17:00",
                "endTime": "2020-11-30 18:00",
                "clidFirst": 10,
                "clidSecond": 1,
                "clidThird": 3
              }
            ]
          }
        }

        commit('SET_METTINGDATA', meetingData(_MeData));
        resolve();
        // getMeetingData_api({
        //   gid: state.Cookie.Gid
        // }).then((res) => {


        //   console.log(res)

        //   commit('SET_METTINGDATA', meetingData(res))


        // }).catch(err => {

        //   reject(err)
        // })

      })
    },

    // 预约会议

    SendOrder({
      commit,
      state,
      dispatch
    }, param) {
      let _obj = {
        Email: state.Cookie.UserEmail,
        GId: state.Cookie.Gid
      }
      return new Promise((resolve, reject) => {
        sendUserOrder_api(Object.assign(param, _obj)).then(res => {
          resolve(res);
        }).catch(err => {
          console.log(err)
          reject(err)
        });
      })

    },

    //个人中心已预约信息
    GetOrder({
      commit,
      state,
      dispatch
    }) {
      return new Promise((resolve, reject) => {
        getUserOrder_api().then(res => {

          commit('SET_ORDERDATA', OrderMeetingData(res))

        }).catch(err => {

          reject(err)
        })
      })

    },


    /**
     * 用于修改页面文字内容
     * param {} obj
     */
    ChangeContentText({
      commit
    }, param) {
      return new Promise((resolve, reject) => {
        resolve()
      })
    },

    /**
     * 统计代码 Pv
     *
     */

    SetUserPvAaction({
      commit,
      state
    }, param) {

      if (!global.GETUSERACTION) { //开关判断
        return false
      }
      if (typeof param != 'object') {
        console.error(param, '必须为object')
        return false
      }

      return new Promise((resolve, reject) => {
        sendPvAction_api(Object.assign(param, state.Cookie)).then(res => {
          resolve()
        }).catch(err => {
          reject()
        })

      })
    },
    /**
     * 统计代码 UV
     *
     */

    SetUserUvAaction({
      commit,
      state
    }, param) {
      if (!global.GETUSERACTION) {
        return false
      }
      if (typeof param != 'object') {
        console.error(param, '必须为object')
        return false
      }
      return new Promise((resolve, reject) => {
        sendUvAction_api(Object.assign(param, state.Cookie)).then(res => {
          resolve()
        }).catch(err => {
          reject()
        })
      })
    },
    /**
     * 获取福来号码
     *
     * @param {*} param
     */
    getLuckyCode({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        getRandomLuckyCode_api(state.Cookie['Gid']).then(res => {
          commit('SET_LUCKYNUMBER', res['data']['data'].data || []);
          resolve()
        }).catch(err => {
          reject()
        })
      })
    },

  },
  mutations: {
    SET_ISMOBILE: (state, active) => {
      state.IsMobile = active
    },
    SET_ROATEUSER: (state, active) => {
      state.RoateUser = active
    },
    SET_DOWNLOAD: (state, active) => {
      state.Download = active
    },

    SET_COOKIE: (state, active) => {
      state.Cookie = active;
    },
    SET_METTINGDATA: (state, active) => {
      state.MettingData = Object;
      state.MettingData = active
    },
    SET_ORDERDATA: (state, active) => {
      state.UserOrder = Object;
      state.UserOrder = active
    },

    SET_INTERACT: (state, active) => {
      state.Interact = active
    },
    INTERACTPROESS: (state, active) => {
      state.InteractProess = active
      // let _array = [];
      // let _baseArray = [1, 2, 4, 8, 16];

      // _baseArray.forEach(ele => {
      //   if ((ele & active) > 0) {
      //     _array.push(ele)
      //   }
      // })

      // state.InteractProess = null;
      // state.InteractProess = _array;
    },
    SET_VIDEODATA: (state, active) => {
      state.VideoData = Array;
      state.VideoData = active
    },
    SET_USERACTVE: (state, active) => {
      state.UserActive = active;
      localStorage.setItem('userActive', JSON.stringify(active))
    },

    SET_LUCKYNUMBER: (state, active) => {
      state.LuckyNumber = active.sort((a, b) => parseInt(a.group) - parseInt(b.group));
    },
    SET_CURRENTVID: (state, active) => {
      state.CurrentVid = active;
    }

  }

}

export default baseInfo
